// extracted by css-extract-rspack-plugin
export default {"container":"mRXil","readonly":"otKmw","submitBtn":"flQRQ","active":"ClWwU","content":"vxmXQ","contentWrapper":"CvuZI","canSubmit":"vE6Xb","bubbleMenu":"UBbj7"};